(function () {
  function init() {
    var nav = document.getElementById('hv3-mobile-nav');
    if (!nav || nav.dataset.hv3Init) return;
    nav.dataset.hv3Init = '1';

    var panels = {};
    nav.querySelectorAll('.hv3-mnav__panel').forEach(function (p) { panels[p.id] = p; });
    var stack = ['hv3p-root'];

    function render() {
      var top = stack[stack.length - 1];
      Object.keys(panels).forEach(function (id) {
        var p = panels[id];
        if (id === top) {
          p.style.transform = 'translateX(0)';
          p.classList.add('is-active');
          p.removeAttribute('aria-hidden');
        } else if (stack.indexOf(id) > -1) {
          p.style.transform = 'translateX(-100%)';
          p.classList.remove('is-active');
          p.setAttribute('aria-hidden', 'true');
        } else {
          p.style.transform = 'translateX(100%)';
          p.classList.remove('is-active');
          p.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function open() {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hv3-mnav-lock');
    }
    function close() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hv3-mnav-lock');
      stack = ['hv3p-root'];
      // Reset sans animation visible après fermeture
      window.setTimeout(render, 300);
    }

    // Ouverture depuis le(s) hamburger(s)
    document.querySelectorAll('.hv3 .mobile-nav-toggle').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        open();
      });
    });

    nav.addEventListener('click', function (e) {
      var drill = e.target.closest('[data-hv3-target]');
      var back = e.target.closest('[data-hv3-back]');
      var closer = e.target.closest('[data-hv3-close]');
      if (drill) {
        var id = drill.getAttribute('data-hv3-target');
        if (panels[id] && stack[stack.length - 1] !== id) { stack.push(id); render(); }
      } else if (back) {
        if (stack.length > 1) { stack.pop(); render(); }
      } else if (closer) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });

    render();
  }

  init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('#hv3-mobile-nav')) init();
  });
})();
